var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 113,
    viewBox: "0 0 343 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343 90.5C343 102.65 333.15 112.5 321 112.5L22 112.5C9.84974 112.5 7.99982e-07 102.65 1.78681e-06 90.5L7.35027e-06 22.0001C8.3371e-06 9.8498 9.84974 9.02221e-05 22 9.07505e-05L291.5 0.000102471C297.023 0.000102712 301.5 4.47725 301.5 10.0001L301.5 18.5001C301.5 28.9935 310.007 37.5001 320.5 37.5001L327 37.5001C335.837 37.5001 343 44.6635 343 53.5001L343 90.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.f2974b0d88be9aa0f442b049e7a74294.svg";
export { ForwardRef as ReactComponent };